<template>
  <div class="bg-main documents vh-100">
    <VuePullRefresh
      :key="pullKey"
      :on-refresh="appRefresh"
      :config="{
        startLabel: '',
        readyLabel: '',
        loadingLabel: '',
        pullDownHeight: 100,
        maxHeight: 120,
      }"
    >
      <v-container class="pt-0 px-0 pb-10 bg-main" fluid>
        <v-alert
          v-if="!$online"
          dense
          tile
          color="gray"
          icon="mdi-alert-circle-outline"
          class="alert-offline text-headline"
        >
          {{ $t("t_no_connection") }}
        </v-alert>
        <v-card flat class="bg-main" tile>
          <v-card-text class="d-flex pb-0" v-if="$platform == 'web'">
            <p class="headline mb-0">{{ $t("t_documents") }}</p>
            <v-spacer></v-spacer>
            <v-btn
              v-if="$vuetify.breakpoint.mdAndUp"
              icon
              class="ml-2"
              :class="{ rotate: this.$store.state.loader.loading }"
              @click="refresh"
              ><v-icon>mdi-refresh</v-icon></v-btn
            >
          </v-card-text>
          <DocumentList ref="documentList" :documentsTakeNum="25" />
        </v-card>
      </v-container>
    </VuePullRefresh>
  </div>
</template>
<script>
import Helpers from "@/mixins/helpers";
import DocumentList from "@/components/documents/DocumentList.vue";
import VuePullRefresh from "vue-pull-refresh";

export default {
  name: "Documents",
  metaInfo: {
    title: "Documents",
  },
  mixins: [Helpers],
  components: { VuePullRefresh, DocumentList },
  data: () => ({
    pullKey: 0,
  }),
  methods: {
    refresh() {
      this.$refs.documentList.loadDocuments(true);
    },
    appRefresh() {
      this.$refs.documentList.loadDocuments(true);
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
          this.pullKey += 1;
        }, 1000);
      });
    },
  },
};
</script>
